import React, { useEffect, useState } from "react";
import { LOGO } from "@/assets/images";

export default function Navbar({ lang, setLang, t }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { id: "about", label: t.nav.about },
    { id: "menu", label: t.nav.menu },
    { id: "gallery", label: t.nav.gallery },
    { id: "reviews", label: t.nav.reviews },
    { id: "contact", label: t.nav.contact },
  ];

  return (
    <nav
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#F5F2EB]/95 backdrop-blur-md border-b border-[#1A1A1A]/10"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 sm:px-10 lg:px-16">
        <a
          href="#hero"
          data-testid="nav-logo"
          className="flex items-center gap-3"
        >
          <span className="relative inline-flex h-11 w-11 items-center justify-center overflow-hidden rounded-full bg-[#F5F2EB] ring-1 ring-[#1A1A1A]/10">
            <img
              src={LOGO}
              alt="Telleixako Benta"
              className="h-full w-full object-cover"
            />
          </span>
          <span
            className={`hidden font-serif-display text-xl italic tracking-tight transition-colors sm:inline ${
              scrolled ? "text-[#1A1A1A]" : "text-[#F5F2EB]"
            }`}
          >
            Telleixako Benta
          </span>
        </a>

        <div className="hidden items-center gap-10 lg:flex">
          {links.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={`nav-link-${l.id}`}
              className={`link-underline font-body text-xs uppercase tracking-[0.3em] transition-colors ${
                scrolled
                  ? "text-[#1A1A1A] hover:text-[#5C3A21]"
                  : "text-[#F5F2EB]/85 hover:text-white"
              }`}
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-4">
          <div
            className={`hidden sm:flex items-center text-xs font-body uppercase tracking-[0.25em] border ${
              scrolled
                ? "border-[#1A1A1A]/30 text-[#1A1A1A]"
                : "border-[#F5F2EB]/40 text-[#F5F2EB]"
            }`}
            data-testid="lang-toggle"
          >
            <button
              onClick={() => setLang("es")}
              data-testid="lang-es"
              className={`px-3 py-1.5 transition-all ${
                lang === "es"
                  ? scrolled
                    ? "bg-[#1A1A1A] text-[#F5F2EB]"
                    : "bg-[#F5F2EB] text-[#1A1A1A]"
                  : ""
              }`}
            >
              ES
            </button>
            <button
              onClick={() => setLang("eu")}
              data-testid="lang-eu"
              className={`px-3 py-1.5 transition-all ${
                lang === "eu"
                  ? scrolled
                    ? "bg-[#1A1A1A] text-[#F5F2EB]"
                    : "bg-[#F5F2EB] text-[#1A1A1A]"
                  : ""
              }`}
            >
              EU
            </button>
          </div>

          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-mobile-toggle"
            className={`lg:hidden font-body text-xs uppercase tracking-[0.25em] ${
              scrolled ? "text-[#1A1A1A]" : "text-[#F5F2EB]"
            }`}
            aria-label="Menu"
          >
            {open ? "Cerrar" : "Menú"}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-[#1A1A1A]/10 bg-[#F5F2EB]"
        >
          <div className="flex flex-col px-6 py-4">
            {links.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${l.id}`}
                className="border-b border-[#1A1A1A]/10 py-3 font-body text-xs uppercase tracking-[0.3em] text-[#1A1A1A]"
              >
                {l.label}
              </a>
            ))}
            <div className="mt-4 flex gap-2">
              <button
                onClick={() => setLang("es")}
                data-testid="mobile-lang-es"
                className={`flex-1 border border-[#1A1A1A]/30 py-2 text-xs tracking-[0.25em] ${
                  lang === "es" ? "bg-[#1A1A1A] text-[#F5F2EB]" : "text-[#1A1A1A]"
                }`}
              >
                ES
              </button>
              <button
                onClick={() => setLang("eu")}
                data-testid="mobile-lang-eu"
                className={`flex-1 border border-[#1A1A1A]/30 py-2 text-xs tracking-[0.25em] ${
                  lang === "eu" ? "bg-[#1A1A1A] text-[#F5F2EB]" : "text-[#1A1A1A]"
                }`}
              >
                EU
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
